<script setup>
import noc from '@/noc/noc'
</script>
<template>
    <div :id="id" class="hidden top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 fixed w-full lg:w-[50vw] lg:h-auto lg:max-h-[95vh] h-full flex flex-col bg-white text-slate-600 rounded-xl shadow border overflow-hidden opacity-0" :style="getZIndex">
        <div v-if="getHeader" class="h-auto w-full relative bg-slate-200 px-3 py-2 text-center">
            <h1 class="font-bold cursor-default">{{ title }}</h1>
            <button @click.prevent="noc(`#${id}`).modal('hide')" class="absolute z-20 top-2 right-4"><i
                    class="fa-solid fa-xmark text-red-400"></i></button>
        </div>
        <div class="w-full h-auto p-4 overflow-y-auto">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    props: { 
        id: {
            type: String,
            default: ''
        },
        z: {
            type: String,
            default: '51'
        },
        header: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: ''
        },
        backdrop: {
            default: true
        }
    },
    data() {
        return {
            isShow: false,
            backdropElement: null
        }
    },
    computed: {
        getHeader() {
            return this.header
        },
        getZIndex() {
            return `z-index: ${this.z};`
        }
    },
    mounted() {

        noc(`#${this.id}`).listen('ui.modal.show', () => {

            if ( typeof this.backdrop === 'boolean' && this.backdrop) {
                this.backdropElement = document.createElement('div')
                this.backdropElement.setAttribute('class', 'fixed top-0 left-0 w-screen h-screen bg-slate-500/30 backdrop-blur-sm flex justify-center items-center noc-scroll px-2')
                this.backdropElement.setAttribute('style', `z-index: ${parseInt(this.z) - 1};`)
                document.querySelector('#app').appendChild(this.backdropElement)

                this.backdropElement.addEventListener('click', (e) => {
                    noc(`#${this.id}`).modal('hide')
                    setTimeout(() => {
                        try {
                            this.backdropElement.remove()
                        } catch (error) {
                            
                        }
                        this.backdropElement = null
                    }, 200);
                })
            } else if ( typeof this.backdrop === 'string' && this.backdrop === 'static') {
                this.backdropElement = document.createElement('div')
                this.backdropElement.setAttribute('class', 'fixed top-0 left-0 w-screen h-screen bg-slate-500/30 backdrop-blur-sm flex justify-center items-center noc-scroll px-2')
                this.backdropElement.setAttribute('style', `z-index: ${parseInt(this.z) - 1};`)
                document.querySelector('#app').appendChild(this.backdropElement)

                this.backdropElement.addEventListener('click', (e) => {
                    document.querySelector(`#${this.id}`).classList.add('ui-modal-static-animation-beat')
                    setTimeout(() => {
                        document.querySelector(`#${this.id}`).classList.remove('ui-modal-static-animation-beat')
                    }, 1000);
                })

                noc(`#${this.id}`).listen('ui.modal.hide', () => {
                    try {
                        this.backdropElement.remove()
                    } catch (error) {
                        
                    }
                    this.backdropElement = null
                })
            } 
        })

        noc(`#${this.id}`).listen('ui.modal.hide', () => {
            if ( this.backdrop ) {
                this.backdropElement.remove()
                this.backdropElement = null
            }
        })
    }
}
</script>